import { GripIcon } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { SortableFieldProps } from './types';

export function SortableField({ field, onToggle }: SortableFieldProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: field.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-center p-2  border transition-colors ${field.enabled
        ? 'bg-indigo-50 border-indigo-200'
        : 'bg-white border-gray-200'
        } ${isDragging ? 'shadow-lg opacity-50' : ''}`}
    >
      <div
        {...attributes}
        {...listeners}
        className="mr-2 text-gray-400 cursor-grab active:cursor-grabbing"
      >
        <GripIcon className="h-4 w-4" />
      </div>
      <label className="flex items-center flex-1 cursor-pointer">
        <input
          type="checkbox"
          checked={field.enabled}
          onChange={() => onToggle(field.id)}
          className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 "
        />
        <span className="ml-2 text-sm text-gray-700">{field.label}</span>
      </label>
    </div>
  );
}
